<template>
  <div class="snail_doubleDan_layout">
    <!-- 活动标题 -->
    <div v-wechat-title="'最强蜗牛'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class="preloading preloading-snail-doubleDan" v-show='preloadingShow'>
        <div class="load">123</div>
        <div class="entrance-box" v-if="!timeShow" @click="quicklyClick">
          <div class="p-1" v-html="useEntranceWords[useEntranceWords.length - 1]"></div>
        </div>
        <div class="get_btn" v-if="!timeShow && canCloseEntrance" @click="onPopup('preloadingShow')"></div>
      </div>
    </transition>
    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' v-on:channelCallback='selectCallback' :gameName="gameName" :downloadUrl="downloadUrl"
      :loginTypes="loginTypes" channelTips="角色UID可在游戏中—设置—UID查看" noAuthLogin></Login>
    <Os v-if='isShowOs' v-on:selectCallback='selectCallback' v-on:logoutCallback='osCancell' :gameName="gameName"></Os>

    <Header ref="Header" :config='headerConfig' :isShowInfo='true' :isOnline='1' v-if='!preloadingShow' />

    <div :class="'snail_doubleDan_layout_page ' + (isSafari ? 'safari' : '')" v-if='!preloadingShow'>

      <div class="snail_doubleDan_layout_page_main" v-if="!questionnaire_show">
        <div class="title">史上最强福利活动</div>
        <div class="tips text_indent"> 为了防止你们看到一堆文字就跑路，提前告诉你们，往下翻有几个<span
            class="tips_important importantColor">礼包</span>可以拿...
        </div>

        <div class="line"></div>
        <div class="text">亲爱的蜗爷，您们好： </div>
        <div class="text text_indent">自我介绍一下，我是新加入《最强蜗牛》活动2组的新人<span class="importantColor">胖橘</span>，蜗爷们随便叫我小橘、橘长都阔以!
        </div>
        <div class="text text_indent">本来你们点进来看到的应该是一个特效拉满、风格怪诞、玩法有趣的活动，但是很遗憾，这是一封乞讨信……</div>
        <div class="text text_indent">Emmm...事情的起因其实是这样的</div>
        <img @click="getImageSrc" class="chat_img" :src="chatImgArr.chat_1" alt="">
        <div class="text text_indent"> 我们部门从12月开始励精图治，狂搞改革，对每一次H5网页活动下了离谱的KPI，如果达不成，我将面临惩罚——工资以白蝌蚪形式进行发放。</div>
        <div class="text text_indent"> 而我和程序小姐姐——12月刚加入的新人，自然迎上了改革的春风。我们的第一个活动目标就是：</div>
        <img @click="getImageSrc" class="chat_img" :src="chatImgArr.chat_2" alt="">
        <div class="text_tips_1 text_center"> 接下来蜗爷将看到第一个KPI考核点，礼包领取人数大于10万</div>
        <div class="text_tips_1 text_center text_weight spacing_mini"> 在此，我真诚向各位蜗爷滑跪！！</div>
        <div class="text_tips_1 text_center text_weight importantColor spacing_mini tips_margin_mini"> 点击下面的按钮！</div>
        <div class="text_tips_1 text_center text_weight importantColor spacing_mini"> （虽然它看起来长得不像一个按钮）</div>
        <div
          :class="user_activity.fu_one ? 'benefit_b  benefit benefit_center tips_margin2' : 'benefit benefit_center tips_margin2'"
          @click='getReaward(1)'></div>
        <div class="text_tips text_center  importantColor"> 这里放了666白蝌蚪，我大方吧？我现在兜里只有1000白蝌蚪</div>
        <div class="text_tips text_center  "> (当前领取了{{ activity.fu_one_number || 0 }}个)</div>
        <div class="text_tips1 text_center tips_margin2"> 大声逼逼:奖励领取时间截止到<span class="importantColor">2025/1/3
            23:59</span>记得领~得领~领!!</div>
        <div class="text text_indent ">
          话说回来，我有时怀疑自己，是不是得罪了组长？难道是因为我--偷吃他的奶味钙片...被发现了..吧?但是！惹到我们00后，你可算是踢到软柿子了，QAQ不让我好过，我就拉坨大的给你看！！
        </div>
        <img @click="getImageSrc" class="chat_img" :src="chatImgArr.think" alt="">
        <div class="text text_indent ">
          这个页面捏，是我和刚来的程序小姐姐做出来的，没错，连美术都没有！但领导这么做一定有他的道理：）就好像我努力拼出——如此史无前例、无人能及的极简风美术页面，都在我自己的节奏里，补药管我！ </div>
        <img @click="getImageSrc" class="chat_img" :src="chatImgArr.chat_3" alt="">
        <div class="text text_indent ">
          左思右想后，我悟了~~反正这些领导都不会看活动内容，只会看看后台数据啦~所以这个活动长啥样不重要，重要的<span
            class="importantColor text_del">一手交问卷，一手拿奖励</span>，蜗爷们拿到奖励，顺手点点完成我的KPI~Let's win-win！</div>
        <div class="img_box"><img @click="getImageSrc" :src="chatImgArr.left" alt=""><img @click="getImageSrc"
            :src="chatImgArr.right" alt=""></div>
        <div class="text text_indent ">
          我们打工银~玩的不就是欺上瞒下咩......蜗爷，以后你们在游戏里有想要的，记得来找我，我一定还。（呜呜呜感谢蜗爷恩情，小橘不会忘记哒！） </div>
        <div class="text text_center text_weight1 tips_margin_mini">小橘我豁出去也要 </div>
        <div class="text text_center text_weight1 importantColor">给各位蜗爷把双旦福利献上！！！ </div>
        <img @click="getImageSrc" class="img_mini2 tips_margin" :src="chatImgArr.up" alt="">
        <div class="text_1 text_center text_weight1 importantColor tips_margin tips_margin_top">礼包按钮在此，尊贵的蜗爷点一点！！！
        </div>
        <div
          :class="user_activity.fu_two ? 'benefit1_b benefit1 benefit_center tips_margin tips_margin_mini' : 'benefit1 benefit_center tips_margin tips_margin_mini'"
          @click='getReaward(2)'></div>
        <div class="text_tips text_center  importantColor"> 塞了6张抽奖券，祝你欧气满满~</div>
        <div class="text_tips text_center"> （当前领取 {{ activity.fu_two_number || 0 }}个）</div>
        <div class="tips_margin1"> </div>
        <div class="text text_center  tips_margin tips_margin1">当这段话打完的时候 </div>
        <div class="text text_center  tips_margin">我们见到了</div>
        <div class="text text_center  tips_margin">凌晨两点的月亮</div>
        <div class="text text_center  tips_margin">永远闪烁不停的钉钉 </div>
        <div class="text text_center  tips_margin">一脸鬼畜微笑的蜗牛</div>
        <div class="text text_center  tips_margin">和镜子里牛马的自己...... </div>
        <div class="text text_center  tips_margin">其实，抬头再垫垫脚 </div>
        <div class="text text_center  tips_margin">前面会不会是诗和远方？</div>
        <div class="img_box1 tips_margin_top">
          <img @click="getImageSrc" :src="chatImgArr.moon" alt="">
          <img @click="getImageSrc" :src="chatImgArr.hand" alt="">
          <img @click="getImageSrc" :src="chatImgArr.snail" alt="">
        </div>
        <div class="img_box1">
          <img @click="getImageSrc" :src="chatImgArr.light" alt="">
          <img @click="getImageSrc" :src="chatImgArr.room" alt="">
          <img @click="getImageSrc" :src="chatImgArr.handrail" alt="">
        </div>
        <img @click="getImageSrc" class="img_mini1 " :src="chatImgArr.line" alt="">
        <div class="text text_left">如果这次24h之内不出活动</div>
        <div class="text text_left text_bottom">组长说让我们去<span class="text_blue">见见BOXX直聘</span> </div>
        <div class="text text_indent"> 时间就像海绵里的水，挤一挤，一直都会有的，点点之水可以汇海，小橘在此立下一个Flag，我，要努力变强！<span
            class="text_mini">（坐上组长的位置）</span></div>
        <div class="text text_left">————胖橘</div>
        <div class="text  text_indent tips_margin "> 蜗爷，辛苦您看到这里！ </div>
        <div class="text text_indent   "> 我动用了组长默认的权限，和抠搜策划疯狂扯皮，准备了这些礼包，望蜗爷们笑纳。
        </div>
        <div class="text text_indent   ">
          <span class="importantColor"> 顺便帮我点一下分享按钮，</span> 程序小姐姐已经偷偷修改了代码，不用真的分享，点一下就可以拿奖励了嘻嘻。
        </div>
        <div class="text text_indent   ">
          <span class="importantColor">最最最后一个请求——填填问卷吧！</span> 给个好评吧！问卷内容组长会看！！别逼我跪下来求你们！
        </div>
        <div class="btns tips_margin_top">
          <div class="share">
            <div class="btn" @click="onPopup('shareShow')"> </div>
            <div class="text_tips tips_text_bottom3 importantColor">嘘~小橘悄悄加的10个运营福利</div>
            <div class="text_tips tips_text_bottom1">当前分享 {{ activity.share_reward_number || 0 }}次</div>
          </div>
          <div class="questionnaire_btn" ref="questionnaire">
            <div :class="user_activity.is_answer ? 'btn questionnaire_b' : 'btn'"
              @click="onPopup('questionnaire_show')"></div>
            <div class="text_tips tips_text_bottom2 importantColor">塞了颗龙珠记得去许愿哦</div>
            <div class="text_tips tips_text_bottom1">当前好评度 {{ activity.answer_reward_number || 0 }}%</div>
          </div>
        </div>
        <div class="text text_indent  tips_margin ">
          感恩！今后我会努力熟悉游戏，争取到更多福利送给蜗爷，速速成长起来，让组长在角落瑟瑟发抖吧！ </div>
      </div>
      <div class="questionnaire_page" v-else>
        <myform ref="myform" @backQuestion="backQuestion" @submit='submit' />
      </div>
      <Footer :gameName="gameName" />
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>

    <!-- 分享弹窗 -->

    <div class="help-share-wrap  popup_wrap" v-if="shareShow" @click.stop="closePopup('shareShow')">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="detail_box">

          <a class="copy" @click="onCopy" id="my-code" href="javascript:;" :data-clipboard-text='shareLink'></a>
        </div>
      </transition>
    </div>

    <div class="time-wrap  popup_wrap" v-if="timeShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="title">活动预告</div>
          <div class="text">距离史上最强福利活动开始还有</div>
          <div class="time">{{ countdown }}</div>
        </div>
      </transition>
    </div>
    <div class="back-wrap popup_wrap" v-show="backShow" @click="closePopup('backShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }" v-show="backShow">
        <div class="detail_box">
          <div class="btns">
            <div class="continue" @click="closePopup('backShow')"></div>
            <div class="out" @click="closePopup('questionnaire_show')"></div>
          </div>

        </div>
      </transition>
    </div>
    <div class="img-wrap popup_wrap" v-show="imgShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }" v-show="imgShow">
        <div class="detail_box">
          <imgComponents :visible.sync="imgShow" :currentIndex="1" :previewImgList="imgPop" :showTools="isWechatBrowser"/>
        </div>
      </transition>
    </div>
  </div>

</template>
<script>
import { Toast, Indicator } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '@/components/Header';
import { headerConfig } from '../headerConfig';
import { onAutoLoginAPI, wechatInfoAPI } from '../api';
import { analysisParams, getRandomString, buriedLogger, wechatBrowser } from '@/utils/utils';
import Footer from "@/components/Footer";
import myform from "../myform/index.vue";
import imgComponents from "../imgComponents/index.vue";
import { onGetInitDataAPI, getReaward, answer, secretFreeLoginApi, onShow } from "../api";
import Clipboard from "clipboard";

export default {
  name: 'demo',
  components: {
    Header,
    Login,
    Os,
    Footer,
    myform,
    imgComponents
  },
  data() {
    return {
      headerConfig,
      gameName: 'snail',
      downloadUrl: "http://snail.qingcigame.com/official/",
      loginTypes: ["sms", "password", "channel"],
      preloadingShow: true,
      titleShow: true,
      preventShow: false,
      logger: null,
      isWechatBrowser: false, // 是否为微信浏览器
      isSafari: false,
      chatImgArr: {
        chat_1: require("../../../../assets/images/active/snail/doubleDan/chat1.png"),
        chat_2: require("../../../../assets/images/active/snail/doubleDan/chat2.png"),
        chat_3: require("../../../../assets/images/active/snail/doubleDan/chat3.png"),
        think: require("../../../../assets/images/active/snail/doubleDan/think.png"),
        left: require("../../../../assets/images/active/snail/doubleDan/left.png"),
        right: require("../../../../assets/images/active/snail/doubleDan/right.png"),
        up: require("../../../../assets/images/active/snail/doubleDan/up.png"),


        snail: require("../../../../assets/images/active/snail/doubleDan/snail.png"),
        handrail: require("../../../../assets/images/active/snail/doubleDan/handrail.png"),
        moon: require("../../../../assets/images/active/snail/doubleDan/moon.png"),
        hand: require("../../../../assets/images/active/snail/doubleDan/hand.png"),
        light: require("../../../../assets/images/active/snail/doubleDan/light.png"),
        room: require("../../../../assets/images/active/snail/doubleDan/room.png"),
        line: require("../../../../assets/images/active/snail/doubleDan/line.png"),
        // chat_1 :require('../../../../assets/images/active/hjwq/kfhd/code_img.png')
      },
      imgPop: require("../../../../assets/images/active/snail/doubleDan/room.png"),
      benefitNum: 0,
      benefitNum1: 0,
      questionnaire_show: false,
      userResponses: [],

      activity: {
        "fu_one_number": "0",
        "fu_two_number": "0",
        "share_reward_number": null,
        "answer_reward_number": 0,
        "is_start": false,
        "start_at": "2024-11-11 00:00:00"

      },
      user_activity: {
        answer_reward: false,
        fu_one: false,
        fu_two: false,
        is_answer: false,
        share_reward: false,
        "fu_one_number": null,
        "fu_ two_number": null,
        share_reward_number: null,
        answer_reward_number: null
      },
      user_userInfo: {},
      shareShow: false,
      backShow: false,
      shareLink: '',
      useEntranceWords: [''],
      entranceWords: {
        zh: [
          '画面过于华丽正在加载中....',
          '着色器正在编译中....',
          '警告！<着色器编不出来了！',]
      },
      canCloseEntrance: false,
      imgShow: false,
      countdown: '',
      targetDate: null,
      // targetDate: new Date('2024-12-14T16:00:00'),
      intervalId: null,
      timeShow: false,
      isFirst: null,
      time: 100,
      showNext: false,

    };
  },
  created() {
    // 清空store上的用户数据
    // this.setInitActiveInfo();
    // this.setInitUserInfo();
    // if (
    //   this.$route.query.token
    // ) {
    //   this.token = this.$route.query.token;
    //   this.secretFreeLogin();
    // } else {
    //   this.onGetInitDataAPI();
    // }
    
    this.isFirst = localStorage.getItem('is_first');

    if (this.isFirst === null) {
      this.isFirst = true
      // 如果不存在，表示第一次访问 
      // 存储 is_first 为 true
      localStorage.setItem('is_first', 'true');
    } else {
      this.isFirst = false
    }
    this.isWechatBrowser = wechatBrowser();
    console.log('this.isWechatBrowser', this.isWechatBrowser);
    if (this.isWechatBrowser) { // 在微信app下

    } else {
      // safari下底部被遮住
      if ((/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent))) {
        this.isSafari = true;
      }
    }

    // 埋点
    const bl = buriedLogger('snail', '双旦活动');
    this.logger = bl;

    const reload = () => {
      const { protocol, host } = window.location;
      const link = `${protocol}//${host}/snail/invitation/enter${getRandomString()}`;
      setTimeout(() => {
        window.location.href = `${link}?referer=game`;
      }, 200);
    };
    // reload();

    // this.preloadingShow = false;

    this.isSetShare();
    const { protocol, host } = window.location
    this.shareLink = `【最强蜗牛】捡到一封“实习生乞讨信”，我在其中薅到了『双旦福利』，已超越全国99.99%的蜗牛/黄鹂鸟。你也来试试吧~${protocol}//${host}/snail/doubleDan/enter${getRandomString()}`
    this.onShow()
  },
  mounted() {
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        console.log('userInfo', newValue);
        if (!newValue.account) {
          // TAG: 注销的时候
          // this.clearActiveInfo();
        } else {
          // this.onGetInitDataAPI();
        }
      }
    }
  },
  methods: {
    quicklyClick() {
      if (this.time > 0) {
        this.time = this.time - 50
      }
    },
    updateCountdown() {
      const now = new Date(this.activity.now_time).getTime();
      const timeDifference = new Date(this.activity.start_at).getTime() - now;
      if (timeDifference <= 0) {
        this.timeShow = false
        this.entranceAni()
        clearInterval(this.intervalId);
        return;
      }
      this.activity.now_time = new Date(new Date(this.activity.now_time).getTime() + 1000);
      this.timeShow = true
      // const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

      this.countdown = `${hours}小时 ${minutes}分钟 ${seconds}秒`;
    },
    getImageSrc(event) {
      const imgSrc = event.target.src;
      this.imgPop = imgSrc;
      this.imgShow = true;
      console.log(imgSrc);
      // 你可以在这里进一步处理 imgSrc，例如存储或显示
    },
    // 入场动画
    entranceAni() {
      if (this.useEntranceWords[0].length) {
        return console.log('动画中')
      }
      const that = this;
      const key = 'zh';
      const entranceWords = [...this.entranceWords[key]];
      // 加载文字动画
      const loop = () => {
        setTimeout(() => {
          console.log(that.time)
          const row = entranceWords[0];
          let str = row.slice(0, 1);
          if (str === "<") {
            str = "<br>"
          }
          entranceWords[0] = row.substring(1);
          const useEntranceWords = [...this.useEntranceWords];
          useEntranceWords[useEntranceWords.length - 1] = useEntranceWords[useEntranceWords.length - 1] + str;
          this.useEntranceWords = useEntranceWords;
          if (entranceWords[0].length === 0) {
            entranceWords.shift();
            useEntranceWords.push('');
            this.useEntranceWords = useEntranceWords
          }
          if (entranceWords.length !== 0) {
            setTimeout(() => {
              loop();
            }, that.time)
          } else {
            this.useEntranceWords.pop();
            this.canCloseEntrance = true;
          }
        }, that.time);
      };
      setTimeout(() => {
        loop();
      }, 0)
    },
    onShow() {
      const that = this;
      if (that.showNext) {
        return console.log('showNext')
      }
      that.showNext = true
      onShow().then(response => {
        if (Number(response.code) == 200) {
          this.activity = response.data.activity;
          this.activity.answer_reward_number = Math.round(this.activity.answer_reward_number)
          if (!response.data.activity.is_start) {
            this.updateCountdown()
            this.intervalId = setInterval(this.updateCountdown, 1000);
          } else {
            // this.entranceAni()
            if (this.isFirst) {
              this.entranceAni()
            } else {
              that.onPopup('preloadingShow')
            }
          }
        }
      }).finally(() => {
        setTimeout(() => {
          that.showNext = false
        }, 100)
      })
    },
    // 复制链接
    onCopy() {
      const my_id = '#my-code'
      const that = this
      if (!that.userInfo.role_id) {
        console.log('请先登录')
        that.shareShow = false
        that.changeLoginPopup(true)
        return that.onToast('很抱歉，请先登录');
      }

      this.copyEnd = false;
      setTimeout(() => {
        this.copyEnd = true;
      }, 1000);
      this.shareShow = false
      this.switchShow = false
      const clipboard = new Clipboard('#my-code');
      console.log(clipboard, 'clipboard')
      clipboard.on('success', (e) => {
        that.logger.sum('最强蜗牛_双旦活动,链接复制');
        that.onToast('邀请链接复制成功，快快发送给你的好友吧~');
        e.clearSelection();
        that.onGetInitDataAPI()
      });
      clipboard.on('error', (e) => {
        console.log(clipboard, 'error')
        that.onToast('复制失败');
      });
    },
    onPopup(show) {
      const that = this
      that.logger.sum('最强蜗牛_双旦活动,' + show);
      console.log(that.userInfo)
      if (show == 'preloadingShow' && !that.userInfo.role_id) {
        this[show] = false;
        return this.onGetInitDataAPI()
      }
      if (!that.userInfo.role_id) {
        console.log('请先登录')
        that.changeLoginPopup(true)
        return that.onToast('很抱歉，请先登录');
      }
      if (show == 'questionnaire_show' && that.user_activity.is_answer) {
        return this.onToast('感谢蜗爷，您已好评~')
      }

      if (show == 'preloadingShow') {
        console.log(show)
        this[show] = false;
        return this.onGetInitDataAPI()
      }
      if (show == 'shareShow') {
        this.getReaward(3)
      }
      this[show] = true;
    },
    closePopup(show) {
      if (show == 'questionnaire_show') {
        setTimeout(() => {
          this.$refs.questionnaire.scrollIntoView({ behavior: 'auto' });
        }, 0)
      }
      this[show] = false;
    },

    backQuestion(stop) {
      this.onPopup('backShow')
    },
    submit(res) {
      let query = {}
      const that = this
      Indicator.open();
      res.map((item, index) => {
        query['answer_' + (index + 1)] = item.selectedValues.toString()
      })
      console.log(query)
      answer(query).then(response => {
        console.log(response)
        if (Number(response.code) == 200) {
          console.log('User Responses:', res);
          this.logger.sum('最强蜗牛_双旦活动,' + '提交问卷');
        }
      }).finally(() => {
        that.questionnaire_show = false
        Indicator.close();
        that.onGetInitDataAPI()
      })
      // Logic to handle submission of answers
      // ... send userResponses to server or perform other actions
    },
    // 清除data里面相关数据
    clearActiveInfo() {
      this.user_activity = {
        answer_reward: false,
        fu_one: false,
        fu_two: false,
        is_answer: false,
        share_reward: false,
        "fu_one_number": null,
        "fu_ two_number": null,
        share_reward_number: null,
        answer_reward_number: null
      }
      this.questionnaire_show = false
    },
    getReaward(num) {
      const that = this
      if (!that.userInfo.role_id) {
        console.log('请先登录')
        that.shareShow = false
        that.changeLoginPopup(true)
        return that.onToast('很抱歉，请先登录');
      }
      const rewardText = {
        1: '亲爱滴蜗爷~福利已送达至您的邮箱~',
        2: '亲爱滴蜗爷~第二个福利已送达至您的邮箱~',
      }
      const is_receive_text = {
        1: '亲爱滴蜗爷~福利已送达至您的邮箱~',
        2: '亲爱滴蜗爷~第二个福利已送达至您的邮箱~',
        3: '您已领取过分享奖励~',
      }
      const is_receive = {
        1: 'fu_one',
        2: 'fu_two',
        3: 'share_reward',
      }
      if (num !== 3 && this.user_activity[is_receive[num]]) {
        console.log('已领取')
        return this.onToast(is_receive_text[num])
      }
      getReaward({ type: num }).then(response => {
        console.log(response)
        if (Number(response.code) == 200) {
          that.logger.sum('最强蜗牛_双旦活动,' + `领取奖励${num}`);
          this.onGetInitDataAPI()
          if (num !== 3) {
            this.onToast(rewardText[num])
          }
          if (num === 3 && this.user_activity[is_receive[3]]) {
            this.onToast(is_receive_text[num])
          }
        }
      })
    },
    onGetInitDataAPI() {  // 初始化
      const that = this
      onGetInitDataAPI().then(response => {
        if (Number(response.code) == 200) {
          this.user_activity = response.data.activity;
          this.user_userInfo = response.data.userInfo;
          response.data.user_info = response.data.userInfo;
          response.data.userInfo.role_id = response.data.userInfo.rid
          // delete response.data.userInfo.account
          // this.onInitDataCallback(response);
          this.setUserInfo(response.data.userInfo);
          return;
        }
        // 登录异常
        if (Number(response.code) == 401 && response.data.info) {
          this.onInitDataCallback(response);
          this.tipsMessage("信息加载失败，请先登入游戏", 2000);
          return;
        }
        // 请登录
        if (Number(response.code) == 401) {
          // console.log('请先登录')
          // that.onToast('很抱歉，请先登录');
          // that.changeLoginPopup(true)
          // this.onInitDataCallback(response);
          return;
        }
      }).finally(() => {
        that.onShow()
        Indicator.close();
      });
    },
    // 选择角色后
    selectCallback() {
      if(this.questionnaire_show){
        this.questionnaire_show = false
      }
      this.onGetInitDataAPI();
    },
    // 区组弹窗注销-相关参数复位
    osCancell() {
      this.clearActiveInfo()
    },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    // 微信分享
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/snail/doubleDan/enter${getRandomString()}`,
        title: '双旦福利.txt',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/AG6cPzomBJYsOoCVY3RCvRA9lD6msAUchmLip72f.png',
        desc: '福利直达心趴！求求给个好评...实习小橘编辑于12/20'
      })
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "confirmLogout",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>
<style lang="less">
.snail_doubleDan_layout .account-info .info {
  top: 0.2rem !important;
  width: 5.2rem !important;
}
</style>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/doubleDan/index/index.vue